import { cn } from '@shared/components/shadcn';
import React from 'react';

type OfferStickyPanelProps = {
  children: React.ReactNode;
  className?: string;
};

const OfferStickyPanel: React.FC<OfferStickyPanelProps> = ({ children, className }) => {
  return (
    <section data-track-container="Actions">
      <div className={cn('fixed bottom-0 left-0 right-0 z-50 p-5 bg-background md:hidden shadow-top-m', className)}>
        <div className="[&>*]:w-full" data-testid="sticky-panel">
          {children}
        </div>
      </div>

      <div className={cn('hidden md:block', className)}>{children}</div>
    </section>
  );
};

export { OfferStickyPanel, type OfferStickyPanelProps };
